<div *ngIf="cards != undefined && !isMobile" class="nearby-poi-container">
  <h2 class="base-cursor" translate="">DiscoverNearby</h2>
  <mat-grid-list cols="{{ rowNumber }}" [rowHeight]="320">
    <mat-grid-tile *ngFor="let card of cards?.slice(0, 4)" colspan="1">
      <mat-card
        class="nearby-poi"
        routerLink="/fiche/{{
          card.idSubcategory != undefined
            ? card.idSubcategory.toString()
            : '' + card.category.toString()
        }}/{{ card.id }}"
        (click)="sendUpGaEvent(card); refreshPage()"
      >
        <img
          #img
          mat-card-image
          src="{{ getCurrentImage(card) }}"
          (error)="manageImageError(card, img)"
          alt="{{ card.image?.alt }}"
        />
        <div class="card-title-div">
          <div fxFlex="" class="poi-title-div">
            <mat-card-title
              class="poi-title"
              [innerHTML]="card.title"
            ></mat-card-title>
            <mat-card-subtitle class="poi-subtitle"
              >{{ card.city.name }}
            </mat-card-subtitle>
          </div>
          <div class="cat-icon-button mat-mini-fab card-list-button">
            <mat-icon
              *ngIf="card.category != '1'"
              svgIcon="icon_{{
                card.idSubcategory !== null
                  ? icons[card.idSubcategory.toString()]
                  : card.category
              }}"
            ></mat-icon>
            <mat-icon
              *ngIf="card.category == '1'"
              svgIcon="icon_{{ get_icon(card) }}"
            ></mat-icon>
          </div>
        </div>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

<div *ngIf="cards != undefined && isMobile">
  <h2 class="poi-carrousel-sp-title" translate="">DiscoverNearby</h2>
  <div class="poi-carrousel-sp">
    <div
      *ngFor="let card of cards?.slice(0, 4)"
      routerLink="/fiche/{{
        card.idSubcategory != undefined
          ? card.idSubcategory.toString()
          : '' + card.category.toString()
      }}/{{ card.id }}"
      class="poi-div-sp"
      (click)="sendUpGaEvent(card); refreshPage()"
    >
      <img
        #img_sp
        mat-card-image
        class="poi-img-sp"
        src="{{ getCurrentImage(card) }}"
        (error)="manageImageError(card, img_sp)"
        alt="{{ card.image?.alt }}"
      />
      <div class="footer-div-sp">
        <div class="poi-title-div-sp">
          <mat-card-title
            class="poi-title"
            [innerHTML]="card.title"
          ></mat-card-title>
          <mat-card-subtitle class="poi-subtitle"
            >{{ card.city.name }}
          </mat-card-subtitle>
        </div>
        <mat-icon
          mat-mini-fab
          color="primary"
          *ngIf="card.category != '1'"
          svgIcon="icon_{{
            card.idSubcategory !== null
              ? icons[card.idSubcategory.toString()]
              : card.category
          }}"
        ></mat-icon>
        <mat-icon
          mat-mini-fab
          *ngIf="card.category == '1'"
          svgIcon="icon_{{ get_icon(card) }}"
          color="primary"
        ></mat-icon>
      </div>
    </div>
  </div>
</div>
